/* Category navigation only. Existing quote app integration is unchanged. */
(() => {
  function initialise(scope = document) {
    scope.querySelectorAll('.ufi-shop-menu').forEach(menu => {
      if (menu.dataset.categoryNavigationReady) return;
      menu.dataset.categoryNavigationReady = 'true';
      const links = [...menu.querySelectorAll('[data-ufi-menu-category]')];
      const panels = [...menu.querySelectorAll('[data-ufi-menu-panel]')];
      const overview = menu.querySelector('[data-ufi-menu-overview]');
      let lastTrigger;
      function select(key) {
        panels.forEach(panel => { panel.hidden = panel.dataset.ufiMenuPanel !== key; });
        if (overview) overview.hidden = Boolean(key);
        links.forEach(link => {
          const active = link.dataset.ufiMenuCategory === key;
          link.setAttribute('aria-expanded', String(active));
          link.classList.toggle('is-active', active);
        });
      }
      links.forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const key = link.dataset.ufiMenuCategory;
        const panel = panels.find(item => item.dataset.ufiMenuPanel === key);
        if (!panel) return;
        event.preventDefault(); lastTrigger = link; select(key);
        panel.querySelector('[data-ufi-menu-back]')?.focus({preventScroll:true});
      }));
      menu.querySelectorAll('[data-ufi-menu-back]').forEach(button => button.addEventListener('click', () => {
        select(null); lastTrigger?.focus({preventScroll:true});
      }));
      menu.addEventListener('toggle', () => { if (!menu.open) select(null); });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
